module.exports = __webpack_public_path__ + "fd7adf1b58ade5960e005e4a133bddec.pdf";